import React from 'react';

import { Button } from 'app/SharedComponents/Button/Button';

import { ModalBase, ModalBaseProps } from '.';

interface ModalInfoProps extends ModalBaseProps {
  buttonText?: string;
  buttonVariant?: 'contained' | 'outlined';
  onButtonClick?: () => void;
  withButton?: boolean;
}

export const ModalInfo = React.memo(
  ({
    buttonText = '',
    buttonVariant = 'outlined',
    children,
    onButtonClick,
    withButton = false,
    ...props
  }: ModalInfoProps) => (
    <ModalBase {...props}>
      {children}
      {withButton && buttonText && (
        <Button
          data-testid="modal-button-test"
          fullWidth
          onClick={onButtonClick}
          variant={buttonVariant}
          className="mt-4"
        >
          {buttonText}
        </Button>
      )}
    </ModalBase>
  ),
);
